import { RouteRecordRaw } from "vue-router";
import { HOME_URL } from "@/config"; // LOGIN_URL

/**
 * staticRouter (静态路由)
 */
export const staticRouter: RouteRecordRaw[] = [
  {
    path: "/",
    // redirect: HOME_URL,
    meta: {},
    children: []
  },

  // {
  //   path: LOGIN_URL,
  //   name: "login",
  //   // Component: "/login/index",
  //   component: () => import("@/views/login/index.vue"),
  //   meta: {
  //     title: "登录",
  //     isLink: "",
  //     isHide: true,
  //     isFull: false,
  //     isAffix: true,
  //     isKeepAlive: true
  //   },
  //   children: []
  // },
  {
    path: "/verifyLogin",
    name: "verifyLogin",
    component: () => import("@/views/login/verifyLogin.vue")
  },
  {
    path: "/layout",
    name: "layout",
    // component: () => import("@/layouts/index.vue"),
    component: () => import("@/layouts/indexAsync.vue"),
    redirect: HOME_URL,
    meta: {},
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首页",
          isFull: false
        },
        children: []
      }
    ]
  },
  {
    path: "/layoutqywx",
    name: "layoutqywx",
    // component: () => import("@/layoutsQYWeixin/index.vue"),
    component: () => import("@/layoutsQYWeixin/indexAsync.vue"),
    // redirect: LOGIN_URL,
    children: []
  }
  // {
  //   path: "/cloud",
  //   name: "cloud",
  //   // component: () => import("@/layouts/index.vue"),
  //   redirect: HOME_URL,
  //   meta: {},
  //   children: [
  //     {
  //       path: "/cloud/selfInfo",
  //       name: "selfInfo",
  //       component: () => import("@/views/case/info.vue"),
  //       meta: {
  //         title: "自助报价"
  //       }
  //     },
  //     {
  //       path: "/cloud/refer",
  //       name: "refer",
  //       component: () => import("@/views/quota/quotaCase.vue"),
  //       meta: {
  //         title: "参考"
  //       }
  //     },
  //     {
  //       path: "/cloud/case",
  //       name: "case",
  //       component: () => import("@/views/case/templates.vue"),
  //       meta: {
  //         title: "案例",
  //         isHide: false
  //       }
  //     },
  //     {
  //       path: "/cloud/infoDetails/:id",
  //       name: "infoDetails",
  //       component: () => import("@/views/case/infoDetails.vue"),
  //       meta: {
  //         title: "报价详情"
  //       }
  //     }
  //   ]
  // }
];

/**
 * errorRouter (错误页面路由)
 */
export const errorRouter = [
  {
    path: "/403",
    name: "403",
    component: () => import("@/components/ErrorMessage/403.vue"),
    meta: {
      title: "403页面"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/components/ErrorMessage/404.vue"),
    meta: {
      title: "404页面"
    }
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/components/ErrorMessage/500.vue"),
    meta: {
      title: "500页面"
    }
  },
  // Resolve refresh page, route warnings
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/components/ErrorMessage/404.vue")
  }
];
